import { encode } from 'js-base64'
const a = "MjAwNi0wMy0wMQ=="
const b = 'QUtJQVpHQk5UMjZWU1lFQUVWQVk='
const c = 'akFra2V5aWZ1cVduNVJaVjNoVXhGOWNNTnU5cmxuN1Q3TUR3NDhybg=='
const d = "dXMtd2VzdC0x"
export default {
  aa: encode(a),
  bb: encode(b),
  cc: encode(c),
  dd: encode(d)
}